var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecentlyLaunched(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-118 -110)",
    stroke: "#314E55",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(127 116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1538 6h37.692l2.1538 43h-42l2.1538-43zm27.846 7c1.1046 0 2-0.89543 2-2s-0.89543-2-2-2-2 0.89543-2 2 0.89543 2 2 2zm-18 0c1.1046 0 2-0.89543 2-2s-0.89543-2-2-2-2 0.89543-2 2 0.89543 2 2 2z",
    fill: "#73C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 22v14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 29h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 11c0-6.0751-4.9249-11-11-11s-11 4.9249-11 11"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentlyLaunched);
export default __webpack_public_path__ + "static/media/recentlyLaunched.dfb60b08f1f6656db00ebba25a082def.svg";
export { ForwardRef as ReactComponent };